import { Toasty } from './toasty.model';

export class Alert extends Toasty {
  get classes(): string[] {
    return [...this.toastyClasses, 'alert'];
  }
}
